import { CircularProgress, Grid } from '@mui/material'
import React from 'react'

const Loader = () => {
    return (
        <Grid
            height={"50vh"}
            xs={12}
            container
            justifyContent={"center"}
            alignItems={"center"}
        >
            <CircularProgress size={80} />
        </Grid>
    )
}

export default Loader